import moment from "moment";

/**
 * Format lastSeen timestamp to human-readable string
 * @param {string|null} lastSeen - ISO date string or null if online
 * @returns {string} Formatted string
 */
export const formatLastSeen = (lastSeen) => {
  if (!lastSeen) return "";

  const date = moment(lastSeen);
  if (!date.isValid()) return "";

  const now = moment();
  const diffMinutes = now.diff(date, "minutes");

  // Less than 1 minute
  if (diffMinutes < 1) {
    return "Vừa mới truy cập";
  }

  // Less than 60 minutes
  if (diffMinutes < 60) {
    return `Hoạt động ${diffMinutes} phút trước`;
  }

  // Today
  if (date.isSame(now, "day")) {
    return `Hoạt động lúc ${date.format("HH:mm")}`;
  }

  // Yesterday
  if (date.isSame(moment().subtract(1, "day"), "day")) {
    return `Hoạt động hôm qua lúc ${date.format("HH:mm")}`;
  }

  // Older
  return `Hoạt động ${date.format("DD/MM/YYYY HH:mm")}`;
};

export default formatLastSeen;
